import React from "react";
import { Loading, TabPanel, TabPanelEmpty, TabPanelError } from "../../components";
import { GetCompliantPageWrapper } from "../../components/layout/GetCompliantPageWrapper";
import { PageHeader } from "../../components/layout/header/Header";
import { useTabs } from "../../hooks";
import { OrganizationUsersTable } from "../../components/users/OrganizationUsersTable";

export const Settings: React.FC = () => {
  const tabOptions = [
    {
      label: "Users",
      value: "users",
    },
  ];
  const [tab, tabs] = useTabs(tabOptions, "users", null, null, "inherit");

  return (
    <GetCompliantPageWrapper>
      <PageHeader titleContent="Settings" />
      <div className="legacy-settings--container">
        <div className="mt-md">{tabs}</div>
        <TabPanel value="users" tab={tab}>
          <OrganizationUsersTable
            loadingElem={<Loading />}
            errorElemFn={(errorMessage: string) => <TabPanelError message={errorMessage} />}
            EmptyElem={<TabPanelEmpty message={"There are no users."} />}
            // With POL-5511 the HR Center is now entirely in Stay Compliant, so don't allow users to add HR users in Get Compliant
            allowAddingHrUser={false}
          />
        </TabPanel>
      </div>
    </GetCompliantPageWrapper>
  );
};
